import { FormlyFieldConfig } from '@ngx-formly/core';
import type { FormlyHookFn } from './formly-hook-fn.type';
import { EMPTY, of, take } from 'rxjs';
import { IntelligentActionContentResult } from '@intellio/shared/models';
import { Observable } from 'rxjs';

export const intelligentActionSetup = (functionName, intelligentActionResultsList$: Observable<IntelligentActionContentResult[]>): FormlyHookFn => {    

    return (field: FormlyFieldConfig) => {     
        if (functionName.length < 3) {
            console.warn(
              'Not enough parameters were provided to the formly hook'
            );
            return EMPTY;
        }

        const args = functionName[1].split(/,(.+)/).map(s => s.trim());
        const ruleName = args[0];
        const instanceIds = args[1].startsWith('[')
            ? JSON.parse(args[1]).map((instanceId: number) => instanceId.toString())
            : [args[1]];

        intelligentActionResultsList$.pipe(
            take(1)
        ).subscribe(
            (data) => {
                var intelligentActionResult = data.find((element) => element.ruleName === ruleName && instanceIds.includes(element.instanceId.toString()));
                if(intelligentActionResult){
                    field.props.notLoaded = false;
                    field.props.result$ = of(intelligentActionResult);
                } else {
                    field.props.notLoaded = true;
                    field.props.result = of(null);
                }
            }
        )
    };
};
